var React = require('react');

function CloseWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.42257 0.930367C4.18209 -0.310122 2.17086 -0.310122 0.930367 0.930367C-0.310122 2.17086 -0.310122 4.18209 0.930367 5.42257L13.5078 18L0.930367 30.5774C-0.310122 31.8179 -0.310122 33.8291 0.930367 35.0696C2.17086 36.3101 4.18209 36.3101 5.42257 35.0696L18 22.4922L30.5774 35.0696C31.8179 36.3101 33.8291 36.3101 35.0696 35.0696C36.3101 33.8291 36.3101 31.8179 35.0696 30.5774L22.4922 18L35.0696 5.42257C36.3101 4.18208 36.3101 2.17086 35.0696 0.930366C33.8291 -0.310121 31.8179 -0.310121 30.5774 0.930366L18 13.5078L5.42257 0.930367Z","fill":"#FFFFFF"}));
}

CloseWhite.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = CloseWhite;

CloseWhite.default = CloseWhite;
